// Core identifiers shared by the Unfathomable engine, server and client.

export type Seat = number;

export type SkillType = "influence" | "lore" | "observation" | "strength" | "will" | "treachery";
export const kSkillTypes: readonly SkillType[] = ["influence", "lore", "observation", "strength", "will", "treachery"];
export const kNonTreacherySkills: readonly SkillType[] = ["influence", "lore", "observation", "strength", "will"];
export const kSkillNameZh: Record<SkillType, string> = {
  influence: "影响", lore: "学识", observation: "观察", strength: "力量", will: "意志", treachery: "背叛",
};

export type Resource = "fuel" | "food" | "sanity" | "souls";
export const kResources: readonly Resource[] = ["fuel", "food", "sanity", "souls"];
export const kResourceNameZh: Record<Resource, string> = {
  fuel: "燃料", food: "食物", sanity: "理智", souls: "灵魂",
};

export type CharacterId =
  | "arjun" | "beatrice" | "edmund" | "ishmael" | "jamie"
  | "jeanne" | "keilani" | "samira" | "svetlana" | "william";

export type LoyaltyType = "human" | "hybrid" | "cultist";

export type MonsterActivation = "hydra" | "dagon" | "deepOnes";
export type TrackIcon = "travel" | "ritual" | "choice";

/** A physical skill card. `uid` is unique per game; `def` keys into the skill card table. */
export interface SkillCard {
  uid: number;
  def: string;
}

export interface PassengerToken {
  uid: number;
  /** Resources lost when defeated; empty array for the "X" token. */
  icons: Resource[];
}

export interface ItemInstance {
  def: string;
  /** Improvement items are active when face up. Non-improvements are always face up. */
  faceUp: boolean;
}

export interface LoyaltyCard {
  uid: number;
  type: LoyaltyType;
}
